<template lang="html">

  <section class="politica-de-cookies">
    <h1>politica-de-cookies Component</h1>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-cookies',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .politica-de-cookies {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue